"use client";
import React, { useEffect, useState } from "react";
import Breadcrumb from "../Common/Breadcrumb";
import { AllProjectsData, DeliveredProjects, WorkedWith } from "./ProjectsData";
import ProjectCardOne from "./ProjectCardOne";
import BreadcrumbTwo from "../Common/BreadcrumbTwo";
import Link from "next/link";
import Image from "next/image";
import Separator from "../Common/Separator";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

export default function ProjectPage() {
  const allProjects = AllProjectsData;
  // console.log("allProjects: ", allProjects);
  const workedWith = WorkedWith;
  const deliveredProjects = DeliveredProjects;
  const defaultView = 4;
  const [view, setView] = useState({});

  function handleClick(category, length) {
    if (view[category] === undefined) {
      view[category] = defaultView;
    }

    view[category] !== defaultView
      ? setView({ ...view, [category]: defaultView })
      : setView({ ...view, [category]: length });
  }

  return (
    <div className="px-20 pt-36">
      {/* <BreadcrumbTwo
        pages={[{ pageName: "Projects", pageHref: "" }]}
        // title={false}
      /> */}
      <div className="mb-5  flex flex-col gap-2">
        <h1 className="text-4xl font-bold dark:text-gray-200">Projects</h1>
        <p className="text-base text-gray-500">
          Where you can find all the projects
        </p>
      </div>
      <Separator className="mt-7" />

      {/* <div className="flex w-full flex-col gap-8  pb-10">
        <h1 className="text-3xl font-semibold">We Have Worked With</h1>
        <div className="flex flex-wrap items-center justify-center gap-8 ">
          {workedWith.map((value, index) => {
            return (
              <div key={index}>
                <ProjectCardOne data={value} />
              </div>
            );
          })}
        </div>
      </div> 
      <div className="flex w-full flex-col gap-8  pb-10">
        <h1 className="text-3xl font-semibold">
          We Have Shipped projects for{" "}
        </h1>
        <div className="flex flex-wrap items-center justify-center gap-8 ">
          {deliveredProjects.map((value, index) => {
            return (
              <div key={index}>
                <ProjectCardOne data={value} />
              </div>
            );
          })}
        </div>
      </div>  */}
      <div className="mb-16">
        {allProjects.map((project, index) => {
          return (
            <div key={index} className="my-10 flex flex-col gap-6">
              <div className="flex items-end justify-between">
                <div>
                  <Link
                    href={`project/${project.Category.replaceAll(" ", "-")}`}
                    className="text-3xl font-semibold"
                  >
                    {project.Category}
                  </Link>
                  <div className="text-base text-gray-500">
                    {project.Description}
                  </div>
                </div>
                {project.projectList.length > defaultView && (
                  <div
                    className="flex cursor-pointer items-center justify-end"
                    onClick={() => {
                      handleClick(project.Category, project.projectList.length);
                    }}
                  >
                    <div className="flex items-center justify-center gap-2 font-medium">
                      View{" "}
                      {view[project.Category] === project.projectList.length ? (
                        <>
                          Less <FaArrowUp />
                        </>
                      ) : (
                        <>
                          More <FaArrowDown />
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="flex flex-wrap gap-10 ">
                {project.projectList
                  .slice(
                    0,
                    view[project.Category]
                      ? view[project.Category]
                      : defaultView,
                  )
                  .map((eachProject, index) => {
                    return (
                      <Link
                        href={`/project/${project.Category.replaceAll(" ", "-")}/${eachProject.Name.replaceAll(" ", "-")}`}
                        key={index}
                        className="flex w-72 flex-col gap-2"
                      >
                        <Image
                          className="rounded-md hover:cursor-pointer"
                          src={eachProject.Image}
                          alt="loaded soon"
                          loading="eager"
                          width={300}
                          height={200}
                        />
                        <div className=" hover:cursor-pointer">
                          <div className="font-medium">{eachProject.Name}</div>
                          <div className="text-sm text-gray-500">
                            {eachProject.Overview}
                          </div>
                        </div>
                      </Link>
                    );
                  })}
              </div>
              {/* {project.projectList.length > defaultView && (
                <div
                  className="mt-5 flex w-full cursor-pointer items-center justify-end"
                  onClick={() => {
                    handleClick(project.Category, project.projectList.length);
                  }}
                >
                  <div className="flex items-center justify-center gap-2 font-medium">
                    View{" "}
                    {view[project.Category] === project.projectList.length ? (
                      <>
                        Less <FaArrowUp />
                      </>
                    ) : (
                      <>
                        More <FaArrowDown />
                      </>
                    )}
                  </div>
                </div>
              )} */}

              {index !== allProjects.length - 1 && (
                <Separator className="mb-5 " />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
